<!-- Standalone page: its own shell and rail. Embedded in a chapter workspace: just the content (the workspace's own
     sidebar stays on screen). -->
<ng-container *ngIf="!embedded; else docsBody">
<div class="section padding-top-120 padding-top-mob-nav section-background-rana rana-shell-flush">
<div class="section-1400 rana-full-bleed">
<div class="container-fluid px-0">
    <div class="row no-gutters rana-shell">
        <div class="col-lg-4 rana-shell-rail">
            <div class="section border-4 p-3 p-xl-4 rana-nav-rail">
                <div class="rana-nav-brand">
                    <div class="rana-nav-brand-mark">
                        <i class="uil uil-file-upload-alt"></i>
                    </div>
                    <div>
                        <div class="rana-nav-brand-title">RANA</div>
                        <div class="rana-nav-brand-subtitle">Admin Tools</div>
                    </div>
                </div>
                <div class="rana-nav-group-label">Media &amp; Downloads</div>
                <a href="javascript:" class="btn btn-user-profile btn-fluid justify-content-start" aria-current="page">
                    <i class="uil uil-file-upload-alt size-22 mr-2 pr-1"></i>
                    Public Document Management
                </a>
            </div>
        </div>
        <div class="col-lg-8 mt-4 mt-lg-0 rana-shell-main">
            <div class="section border-4 p-3 p-xl-4 rana-shell-main-inner">
                <ng-container *ngTemplateOutlet="docsBody"></ng-container>
            </div>
        </div>
    </div>
</div>
</div>
</div>

</ng-container>

<ng-template #docsBody>

            <div class="rana-page-header">
                <div>
                    <h1 class="rana-page-title">Public Document Management</h1>
                    <p class="rana-page-subtitle mb-0">Upload a document to get a permanent public URL you can share
                        in emails, event descriptions, or notifications. Only admins can use this page.</p>
                </div>
            </div>

            <div class="rana-panel rana-doc-panel mb-4" *ngIf="userRole?.DOCUMENT?.includes('CREATE')">
                <div class="rana-panel-title">Upload a Document</div>

                <div class="rana-doc-dropzone" [class.dragging]="isDragging" [class.has-file]="selectedFile"
                     (click)="fileInput.click()"
                     (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onFileDrop($event)">
                    <input #fileInput type="file" class="rana-doc-file-input"
                           accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv"
                           (change)="onFileSelected($event)">

                    <ng-container *ngIf="!selectedFile">
                        <div class="rana-doc-dropzone-icon">
                            <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4"></path><path d="m7 9 5-5 5 5"></path><path d="M4 16v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"></path></svg>
                        </div>
                        <div class="rana-doc-dropzone-text"><strong>Click to upload</strong> or drag and drop</div>
                        <div class="rana-doc-dropzone-hint">PDF, Word, Excel, PowerPoint, image, or text file — up to 10MB</div>
                    </ng-container>

                    <div class="rana-doc-selected-file" *ngIf="selectedFile" (click)="$event.stopPropagation()">
                        <div class="rana-doc-file-icon">
                            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><path d="M14 2v6h6"></path></svg>
                        </div>
                        <div class="min-width-0">
                            <div class="rana-doc-file-name text-break">{{ selectedFile.name }}</div>
                            <div class="rana-doc-file-size">{{ formatSize(selectedFile.size) }}</div>
                        </div>
                        <button type="button" class="rana-doc-file-remove" (click)="clearSelectedFile()" aria-label="Remove selected file">
                            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
                        </button>
                    </div>
                </div>

                <button type="button" class="rana-action-btn rana-action-btn-success rana-doc-upload-btn"
                        [disabled]="!selectedFile || uploading" (click)="upload()">
                    <i class="uil" [class.uil-spinner-alt]="uploading" [class.spin-animation]="uploading" [class.uil-cloud-upload]="!uploading"></i>
                    {{ uploading ? 'Uploading...' : 'Upload Document' }}
                </button>

                <div class="rana-doc-success" *ngIf="lastUpload">
                    <div class="rana-doc-success-label">
                        <i class="uil uil-check-circle"></i> Public URL
                    </div>
                    <div class="rana-doc-success-row">
                        <input type="text" class="rana-doc-url-input" [value]="lastUpload.url" readonly
                               (click)="urlInputRef.select()" #urlInputRef>
                        <button type="button" class="rana-action-btn" (click)="copyUrl(lastUpload.url)">
                            <i class="uil uil-copy"></i> Copy
                        </button>
                    </div>
                </div>
            </div>

            <div class="rana-panel rana-doc-panel" *ngIf="userRole?.DOCUMENT?.includes('READ')">
                <div class="rana-doc-list-header">
                    <div class="rana-panel-title mb-0">
                        Existing Documents
                        <span class="rana-badge rana-badge-accent ml-2" *ngIf="documents.length">{{ documents.length }}{{ hasMore ? '+' : '' }}</span>
                    </div>
                    <div class="rana-doc-search">
                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><path d="m21 21-4.3-4.3"></path></svg>
                        <label for="docSearch" class="sr-only">Search documents by filename</label>
                        <input id="docSearch" type="text" placeholder="Search by filename..."
                               [(ngModel)]="searchTerm" [ngModelOptions]="{standalone: true}"
                               (ngModelChange)="onSearchChange($event)">
                    </div>
                </div>

                <div class="rana-doc-empty" *ngIf="loadingDocuments">
                    <i class="uil uil-spinner-alt spin-animation mr-2"></i>Loading documents...
                </div>
                <div class="rana-doc-empty" *ngIf="!loadingDocuments && documents.length === 0 && !searchTerm">
                    No documents uploaded yet.
                </div>
                <div class="rana-doc-empty" *ngIf="!loadingDocuments && documents.length === 0 && searchTerm">
                    No documents match "{{ searchTerm }}".
                </div>

                <div class="table-responsive rana-table-flat" *ngIf="!loadingDocuments && documents.length > 0">
                    <table class="table rana-table align-middle mb-0">
                        <thead>
                        <tr>
                            <th>Document</th>
                            <th>Uploaded</th>
                            <th>Size</th>
                            <th class="text-right">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let doc of documents; trackBy: trackByDocId">
                            <td class="text-break">
                                <div class="rana-doc-row">
                                    <div class="rana-doc-row-icon">
                                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><path d="M14 2v6h6"></path></svg>
                                    </div>
                                    <span class="min-width-0">{{ doc.filename }}</span>
                                </div>
                            </td>
                            <td class="text-nowrap">{{ doc.uploadedDate }}</td>
                            <td class="text-nowrap">{{ formatSize(doc.size) }}</td>
                            <td class="text-right text-nowrap">
                                <button type="button" class="rana-action-btn"
                                        (click)="copyUrl(doc.url)">
                                    <i class="uil uil-copy"></i> Copy URL
                                </button>
                                <button type="button" class="rana-action-btn rana-action-btn-danger ml-1"
                                        *ngIf="userRole?.DOCUMENT?.includes('DELETE')"
                                        (click)="deleteDocument(doc)">
                                    <i class="uil uil-trash-alt"></i> Delete
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="text-center mt-3" *ngIf="hasMore">
                    <button type="button" class="rana-action-btn" [disabled]="loadingMore" (click)="loadMore()">
                        <i class="uil" [class.uil-spinner-alt]="loadingMore" [class.spin-animation]="loadingMore" [class.uil-arrow-down]="!loadingMore"></i>
                        {{ loadingMore ? 'Loading...' : 'Load more' }}
                    </button>
                </div>
            </div>

</ng-template>
